import React, { useState } from "react"
import "./DeviceDownloadData.css"
import { Button, InputGroup, FormControl } from "react-bootstrap"
import { useHelper } from "../contexts/HelperContext"
import JSZip from "jszip"
import { saveAs } from "file-saver"
import firebase from "../firebase"
import readme from "../resources/readme.txt"


export default function DeviceDownloadData({onHide, sensorName, deviceId, dateStart, dateEnd, isAdmin}) {
    const [filename, setFilename] = useState(sensorName);
    const helperCtx = useHelper();

    function onChangeHandler(event) {
        setFilename(event.target.value);
    }

    function onSave() {
        if (filename == "") {
            alert("No filename given")
            onHide()
            return
        }
        if (dateEnd < dateStart) {
            alert("Download end date is before start date")
            onHide()
            return
        }

        if (dateEnd > dateStart + 604800 * 8) {
            console.log("Date range too high", dateEnd - dateStart)
            alert("Download limited to eight weeks")
            onHide()
            return
        }

        console.log(deviceId)
        console.log(dateStart)
        console.log(dateEnd)

        var dateStartAdjusted = dateStart - (60 * 60 * 24) // Subtract a day to ensure full data capture

        var metricsDocsRef = firebase.firestore().collection("sensors").doc(deviceId).collection("cache")
        .where('t0', '>=', dateStartAdjusted)
        .where('t0', '<', dateEnd)

        var channelsDocsRef = firebase.firestore().collection("sensors").doc(deviceId).collection("ch")
        .where('t0', '>=', dateStartAdjusted)
        .where('t0', '<', dateEnd)

        var dataDownload = {}

        document.getElementById("download_spinner").style.visibility = "visible"

        function buildAndSaveZip() {
            var zip = new JSZip();
            var spd_folder = zip.folder("spd")
            var raw_csv = "";
            var currentZone = helperCtx.getLocalTimezoneText();
            var local_date_time;
            var utc_date_time;

            raw_csv += sensorName + ',\n';
            if (isAdmin) {
                raw_csv += 'date (utc), time (utc), date (' + currentZone + '), time (' + currentZone + '), lux, cct, cs, medi, X, Y, Z, f1, f2, f3, f4, f5, f6, f7, f8, clr, nir,\n';
            } else {
                raw_csv += 'date (utc), time (utc), date (' + currentZone + '), time (' + currentZone + '), lux, cct, cs, medi,\n';
            }
            var count = 3;
            var keys = Object.keys(dataDownload)
            keys = keys.map(x => parseInt(x,10))
            keys.sort(function(a, b){return a - b});
            console.log("keys", keys)

            for(let i = 0; i < keys.length; i ++) {
                let k = keys[i]
                let vars = dataDownload[k]
                utc_date_time = helperCtx.getUTCDateTextMilitary(k)
                local_date_time = helperCtx.getLocalDateTextMilitary(k);

                if (isAdmin) {
                    raw_csv += utc_date_time + ', ' + local_date_time + ',' + vars.lux + ', ' + vars.cct + ', ' +
                    vars.cs + ', ' + vars.medi + ', ' + vars.X + ', ' + vars.Y + ', ' + vars.Z + ', ' +
                    vars.f1 + ', ' + vars.f2 + ', ' + vars.f3 + ', ' + vars.f4 +  ', ' +
                    vars.f5 +  ', ' + vars.f6 +  ', ' + vars.f7 +  ', ' + vars.f8 +  ', ' +
                    vars.clr +  ', ' + vars.nir + ',\n';
                } else {
                    raw_csv += utc_date_time + ', ' + local_date_time + ',' + vars.lux + ', ' + vars.cct + ', ' +
                    vars.cs + ', ' + vars.medi + ',\n';
                }

                let spd_index = 400
                let spd_data = vars.spd
                let spd_csv = ""
                if (spd_data) {
                    for(let j = 0; j < spd_data.length; j++) {
                        spd_csv += spd_index + ',' + spd_data[j].toString() + "\n"
                        spd_index += 5
                    }
                    spd_csv = spd_csv.slice(0,spd_csv.length-1)
                    spd_csv += ',\n';
                    spd_folder.file("row_" + count.toString() + ".csv",spd_csv);
                }
                ++count;
            }

            zip.file(sensorName + "_raw.csv", raw_csv);
            fetch(readme).then((result) => {
                result.blob().then((data) => {
                    zip.file("readme.txt", data);
                    zip.generateAsync({type:"blob"})
                        .then(function(content) {
                        saveAs(content, filename + ".zip"); // filesavor.js
                        document.getElementById("download_spinner").style.visibility = "hidden"
                    });
                });
            })
        }

        // Non-admins don't get the channel data, but the cache doesn't always have an spd
        // stored, so calculate the missing ones from ch.  Nothing else from ch is used, and
        // no rows are added that the cache didn't already give us.
        function fetchMissingSpd() {
            channelsDocsRef.get().then((querySnapshot) => {
                console.log("Got channel data for the missing spds")
                querySnapshot.forEach((doc) => {
                    let docData = doc.data()
                    for(let i = 0; i < docData['ts'].length; i++) {
                        let ts = docData['ts'][i]
                        if (dataDownload[ts] && !dataDownload[ts].spd) {
                            dataDownload[ts].spd = helperCtx.getSPD(
                                docData['f1'][i], docData['f2'][i], docData['f3'][i],
                                docData['f4'][i], docData['f5'][i], docData['f6'][i],
                                docData['f7'][i], docData['f8'][i], docData['clr'][i], docData['nir'][i]
                            )
                        }
                    }
                });
                buildAndSaveZip();
            }).catch((err) => {
                // ch may not be readable for every account.  Save what the cache gave us.
                console.log("channel data for the missing spds failed", err)
                buildAndSaveZip();
            })
        }

        function fetchCache(onDone) {
            metricsDocsRef.get().then((querySnapshot) => {
                console.log("Got cache data for download")
                querySnapshot.forEach((doc) => {
                    let docData = doc.data()
                    console.log(doc.id, " => ", docData);
                    for(let i = 0; i < docData['ts'].length; i++) {
                        let ts = docData['ts'][i]
                        if (!dataDownload[ts]) {
                            dataDownload[ts] = { unixtime: ts, lux: 0, cct: 0, cs: 0, medi: 0 }
                        }
                        var channelDoc = dataDownload[ts]
                        if (docData.hasOwnProperty("cct")) {
                            channelDoc.cct = docData.cct[i]
                        }
                        if (docData.hasOwnProperty("cs")) {
                            channelDoc.cs = docData.cs[i]
                        }
                        if (docData.hasOwnProperty("slux")) {
                            channelDoc.lux = docData.slux[i]
                        }
                        if (docData.hasOwnProperty("spd")) {
                            if (docData.spd.length > i) {
                                var spdString = docData.spd[i]
                                channelDoc.spd = spdString.split(",").map(parseFloat)
                            }
                        }
                        if (docData.hasOwnProperty("cla")) {
                            channelDoc.cla = docData.cla[i]
                        }
                        if (docData.hasOwnProperty("eml")) {
                            channelDoc.medi = docData.eml[i] * 0.9058
                        }
                    }
                });
                onDone();
            })
        }

        if (isAdmin) {
            channelsDocsRef.get().then((querySnapshot) => {
                console.log("Got channel data for download")
                querySnapshot.forEach((doc) => {
                    let docData = doc.data()
                    console.log(doc.id, " => ", docData);
                    for(let i = 0; i < docData['ts'].length; i++) {
                        dataDownload[docData['ts'][i]] = {
                            unixtime: docData['ts'][i],
                            f1: docData['f1'][i],
                            f2: docData['f2'][i],
                            f3: docData['f3'][i],
                            f4: docData['f4'][i],
                            f5: docData['f5'][i],
                            f6: docData['f6'][i],
                            f7: docData['f7'][i],
                            f8: docData['f8'][i],
                            clr: docData['clr'][i],
                            nir: docData['nir'][i],
                            X: docData['X'][i],
                            Y: docData['Y'][i],
                            Z: docData['Z'][i]
                        }
                        let metrics = helperCtx.get6Vars(
                            docData['ts'][i],
                            docData['f1'][i], docData['f2'][i], docData['f3'][i],
                            docData['f4'][i], docData['f5'][i], docData['f6'][i],
                            docData['f7'][i], docData['f8'][i], docData['clr'][i], docData['nir'][i],
                            docData['X'][i], docData['Y'][i], docData['Z'][i]
                        )
                        dataDownload[docData['ts'][i]]['lux'] = metrics['lux']
                        dataDownload[docData['ts'][i]]['cs'] = metrics['cs']
                        dataDownload[docData['ts'][i]]['medi'] = metrics['eml']*0.9058
                        dataDownload[docData['ts'][i]]['cct'] = metrics['cct']
                        dataDownload[docData['ts'][i]]['spd'] = metrics['spd']
                    }
                });
                fetchCache(buildAndSaveZip);
            })
        } else {
            fetchCache(fetchMissingSpd);
        }

        onHide()
    }

    return (
        <div>
            <div className="mdl">
                <div className="mdl-content">
                    <div className="mdl-header">
                        <h4 className="m-3 mdl-title">Save Data</h4>
                    </div>
                    <div className="mdl-body">
                        <InputGroup className="p-3">
                        <InputGroup.Text id="inputGroup-sizing-default">Filename</InputGroup.Text>
                        <FormControl onChange={onChangeHandler} value={filename} aria-label="Default" aria-describedby="inputGroup-sizing-default" />
                        <InputGroup.Text>.zip</InputGroup.Text>
                        </InputGroup>
                    </div>
                    <div className="mdl-footer d-flex">
                        <Button className="m-3" variant="secondary" onClick={onHide}>Cancel</Button>
                        <Button 
                            className="m-3 ms-auto" 
                            variant="primary" 
                            onClick={onSave}
                            disabled={filename === "" ? true : false}
                            >Save</Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
